export * from './useLocalityDetails';
